import React from "react";
import "../Banner.css";

const Banner = ({ setActivePage, setActiveTab }) => {

  const handleStartLearning = () => {
    setActivePage("Video Tutorials"); // Activate header link
    setActiveTab("video"); // Activate tab
    const section = document.getElementById("video-tutorials-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="banner">
      <img src="/images/banner.jpeg" alt="Learning Banner" />

      <div className="banner-content">
        <h1>Revolutionize Your Learning Experience</h1>
        <p>
          Transform traditional education with self-paced video tutorials and
          interactive classroom support for effective learning.
        </p>
        <button className="banner-btn" onClick={handleStartLearning}>
          Start Learning
        </button>
      </div>
    </div>
  );
};

export default Banner;
